import { useCallback, useLayoutEffect } from 'react';
import { useAppDispatch } from 'src/AppContext';
import { userDrop, userProductsCreated } from 'src/services/api';
import { useUser } from 'src/UserContext';
import { useTranslation } from 'react-i18next';
import useCustomHistory from 'src/hooks/useCustomHistory';
import { useModal } from 'src/ModalContext';
import { KY_SERVICE_NAME } from 'src/constants/ky';

export default function User(): JSX.Element {
  const { t } = useTranslation();
  const history = useCustomHistory();
  const dispatch = useAppDispatch();
  const { userInfo, logout } = useUser();
  const { showModal } = useModal();

  useLayoutEffect(() => {
    dispatch({ type: 'SET_GNB_LEFT', name: 'hidden' });
    dispatch({ type: 'SET_GNB_RIGHT', name: 'close' });
    dispatch({
      type: 'SET_GNB_RIGHT_CALLBACK',
      cb: () => {
        history.goBack();
      },
    });
    return () => {
      dispatch({ type: 'RESET_GNB_LEFT' });
      dispatch({ type: 'RESET_GNB_RIGHT' });
      dispatch({ type: 'RESET_GNB_RIGHT_CALLBACK' });
    };
  }, []);

  const onClickPassword = useCallback((e) => {
    e.preventDefault();
    history.push('/user/change');
  }, []);

  const onClickDrop = useCallback(async (e) => {
    e.preventDefault();
    let activatedProducts;

    try {
      activatedProducts = await userProductsCreated();
      if (activatedProducts.products && activatedProducts.products.length > 0) {
        showModal({
          message: t('user/drop_found_products_error'),
          success: () => {
            return;
          },
        });
        return;
      }
    } catch (e) {
      showModal({
        message: t('user/drop_error'),
        success: () => {
          return;
        },
      });
    }

    showModal({
      message: t('user/drop_guide'),
      success: async () => {
        try {
          await userDrop();
          showModal({
            message: t('user/drop_complete', {
              service: KY_SERVICE_NAME,
            }),
            success: () => {
              logout();
              history.push('/');
            },
          });
        } catch (e) {
          console.error(e);
          showModal({
            message: t('user/drop_error'),
            success: () => {
              return;
            },
          });
        }
      },
      fail: () => {
        return;
      },
    });
  }, []);

  return (
    <>
      <div className="container bg-light-gray-1 pt-6 pb-8">
        <div className="N_20_R">{t('user/title')}</div>
        <div className="mt-4 text-greyish-brown">{userInfo.email}</div>
      </div>
      <ul className="mb-32">
        <li className="container py-6 border-b border-ice-blue flex justify-between items-center">
          <span>{t('user/password_title')}</span>
          <a href="#" className="N_12_M text-brown-grey underline" onClick={onClickPassword}>
            {t('user/password_button')}
          </a>
        </li>
        <li className="container py-6 border-b border-ice-blue flex justify-between items-center">
          <span>{t('user/drop_title')}</span>
          <a href="#" className="N_12_M text-brown-grey underline" onClick={onClickDrop}>
            {t('user/drop_button')}
          </a>
        </li>
      </ul>
    </>
  );
}
